module.exports = ".NotAuthorized {\n  padding: 2rem;\n  background-color: white; }\n"